module.exports = __webpack_public_path__ + "images/emoji/rage.31869ab04313c45ad1b6.png";